<template>
    <div>
        <b-navbar type="dark" variant="dark">
            <b-navbar-brand class="text" @click="$router.push({ name: 'Home' })">Kyle Mok</b-navbar-brand>
            <b-navbar-nav class="ml-auto">
                <b-nav-item @click="$router.push({ name: 'Blog' })">Blog</b-nav-item>
                <b-nav-item @click="$router.push({ name: 'Projects' })">Projects</b-nav-item>
                <b-nav-item @click="$router.push({ name: 'Photos' })">Photos</b-nav-item>
                <b-nav-item @click="$router.push({ name: 'Contact' })">Contact</b-nav-item>
            </b-navbar-nav>
        </b-navbar>
    </div>
</template>

<script>
    export default {
        name: "NavBar"
    }
</script>

<style scoped>

</style>